import FilePreview from "@/components/design-system/FilePreview";
import { CourseAssignmentDetail } from "@/types/assignment.model";
import { AssignmentUserSVG } from "@/utils/svg";
import moment from "moment";
import { Fragment } from "react";

export const AssignmentCard = ({
  assignment,
}: {
  assignment: CourseAssignmentDetail;
}) => {
  return (
    <>
      <div className="mb-8">
        <>
          <div className={`flex flex-wrap justify-between items-start mb-4`}>
            <div
              className={`flex ${"items-center"} gap-2 flex-wrap sm:flex-nowrap`}
            >
              <AssignmentUserSVG />

              <div className={`${"flex flex-col items-start justify-start"}`}>
                <p className="font-semibold text-[16px] text-[#1F1F1F] mb-[4px]">
                  {assignment.creator.name}
                </p>
                <p className="text-sm font-semibold text-[#CAC7C7]">
                  {/* {assignment.created_on} */}
                  {moment(assignment.created_date).format("DD-MM-YYYY HH:mm A")}
                </p>
              </div>
            </div>
          </div>

          <div className="bg-[#F6FAFF] rounded-2xl w-full">
            <div className="mb-4 px-[14px] py-[30px] border-b border-[#EEEEEE]">
              {/* File Preview */}
              <FilePreview
                fileUrl={assignment.uploads[0].url}
                fileType={assignment.uploads[0].file_type}
              />
            </div>

            <div className="px-[14px] py-[16px] mb-4 w-full">
              <div className="flex items-center justify-between mb-1 gap-2 sm:gap-4 bg-white rounded-lg py-[12px] px-[20px] w-full">
                <p className="text-sm font-normal text-[#1F1F1F] whitespace-pre-line">
                  {assignment.notes}
                </p>
              </div>
            </div>
          </div>
        </>

        {assignment.threads.length > 0 && (
          <>
            {assignment.threads.map((thread, index) => (
              <Fragment key={thread.id}>
                <div
                  className={`flex flex-wrap ${
                    index % 2 === 0 ? "justify-end" : "justify-between"
                  } items-start mb-4`}
                >
                  <div
                    className={`flex ${
                      index % 2 === 0 ? "flex-row-reverse" : "items-center"
                    } gap-2 flex-wrap sm:flex-nowrap`}
                  >
                    <AssignmentUserSVG />

                    <div
                      className={`${
                        index % 2 === 0
                          ? "flex flex-col items-end justify-end"
                          : ""
                      }`}
                    >
                      <p className="font-semibold text-[16px] text-[#1F1F1F] mb-[4px]">
                        {thread.creator.name}
                      </p>
                      <p className="text-sm font-semibold text-[#CAC7C7]">
                        {/* {assignment.created_on} */}
                        {moment(thread.created_on).format("DD-MM-YYYY HH:mm A")}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-[#F6FAFF] rounded-2xl w-full">
                  {thread.uploads.length > 0 && (
                    <div className="mb-4 px-[14px] py-[30px] border-b border-[#EEEEEE]">
                      {/* File Preview */}
                      <FilePreview
                        fileUrl={thread.uploads[0].url}
                        fileType={thread.uploads[0].file_type}
                      />
                    </div>
                  )}

                  <div className="px-[14px] py-[16px] mb-4 w-full">
                    <div className="flex items-center justify-between mb-1 gap-2 sm:gap-4 bg-white rounded-lg py-[12px] px-[20px] w-full">
                      <p className="text-sm font-normal text-[#1F1F1F] whitespace-pre-line">
                        {thread.notes}
                      </p>
                    </div>
                  </div>
                </div>
              </Fragment>
            ))}
          </>
        )}
      </div>
    </>
  );
};
